import { c as _c } from "react/compiler-runtime";
import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import RichTextHtml from '~/components/RichTextHtml';
import { Media } from '~/payload-types';
function normalizeInternalMediaUrl(url?: string | null): string | null {
  if (!url) return null;
  const urlWithoutHash = url.split('#')[0] ?? url;
  if (urlWithoutHash.startsWith('/')) {
    return urlWithoutHash;
  }
  try {
    const parsed = new URL(urlWithoutHash);
    const sameOriginPath = `${parsed.pathname}${parsed.search}`;
    if (sameOriginPath.startsWith('/api/media/file/') || sameOriginPath.startsWith('/media/')) {
      return sameOriginPath;
    }
  } catch {
    // ignore
  }
  return urlWithoutHash;
}
function isInternalMediaPath(url: string) {
  return url.startsWith('/api/media/file/') || url.startsWith('/media/');
}
function appendQueryParam(url: string, key: string, value: string) {
  try {
    const u = new URL(url, 'http://localhost');
    u.searchParams.set(key, value);
    return url.startsWith('http') ? u.toString() : `${u.pathname}${u.search}`;
  } catch {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }
}
export default function PdfBlock(t0) {
  const $ = _c(12);
  const {
    title,
    description,
    media,
    page
  } = t0;
  let t1;
  if ($[0] !== media.id || $[1] !== media.updatedAt || $[2] !== media.url) {
    const srcBase = normalizeInternalMediaUrl(media.url);
    t1 = srcBase && isInternalMediaPath(srcBase) ? appendQueryParam(srcBase, "v", media.updatedAt ?? String(media.id)) : srcBase;
    $[0] = media.id;
    $[1] = media.updatedAt;
    $[2] = media.url;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const srcWithVersion = t1;
  const src = srcWithVersion ? `${srcWithVersion}#page=${page ?? 1}` : null;
  let t2;
  if ($[4] !== description) {
    t2 = description && <div className="focus-mode:hidden"><RichTextHtml data={description} /></div>;
    $[4] = description;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== src || $[7] !== title) {
    t3 = src ? <div className="relative w-full aspect-[210/297] max-h-[calc(100vh-15rem)] sm:max-h-[calc(100vh-10rem)] min-h-[400px] in-iframe:max-h-none"><iframe className="absolute inset-0 h-full w-full border-0" src={src} title={title || "PDF"} loading="lazy" /><a href={src} target="_blank" rel="noopener noreferrer" aria-label={`${title || "PDF"} in neuem Tab öffnen`} title={`${title || "PDF"} in neuem Tab öffnen`} className="absolute top-12 right-3 inline-flex items-center justify-center rounded-md border border-gray-300 bg-white/90 backdrop-blur-sm p-1.5 text-gray-600 shadow-sm hover:bg-white hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:hidden in-iframe:sm:inline-flex"><svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg></a><a href={src} target="_blank" rel="noopener noreferrer" className="absolute bottom-3 right-3 hidden sm:inline-flex items-center gap-1.5 rounded-lg border border-gray-300 bg-white/90 backdrop-blur-sm px-3 py-1.5 text-xs font-medium text-gray-700 shadow-md hover:bg-white hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 in-iframe:hidden"><svg className="h-4 w-4 text-red-500" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true"><path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" /><path d="M8 12h4M8 8h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>{title || "PDF \xF6ffnen"}<svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg></a></div> : <div className="rounded-lg bg-gray-100 p-4 text-sm text-gray-700">PDF nicht verfügbar.</div>;
    $[6] = src;
    $[7] = title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="w-full space-y-4">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}